module.exports = __webpack_public_path__ + "static/img/banner1.03146c8a.png";